import { z } from "zod";
import {
  Trade,
  ResourceCategory,
  BusinessRole,
} from "@/modules/hub/features/ResourceLibrary/api/getResourceLibraryMetadata/types";

export const PodcastsFilterFormSchema = z.object({
  searchTerm: z.string().optional(),
  isFavoriteOnly: z.boolean().optional(),
  isFeaturedOnly: z.boolean().optional(),
  trades: z.array(z.custom<Trade>()).optional(),
  categories: z.array(z.custom<ResourceCategory>()).optional(),
  businessRoles: z.array(z.custom<BusinessRole>()).optional(),
});

export type PodcastsFilterFormData = z.infer<typeof PodcastsFilterFormSchema>;
